import { useEffect, useState } from 'react';
import { FieldConfig } from '../../../../../components/CustomFormsComponents/CustomField';
import { TEST_IDS } from '../testIds';
import { useAppSelector } from '../../../../../hooks/reduxHooks';
import { NEW_PROVIDER_OR_BUYER_TYPE_OPTIONS } from '../consts';

const useProviderFieldConfig = ({ t, newProviderFormData, handleBlurValidation }: any) => {
    const [providerFieldsConfig, setProviderFieldsConfig] = useState<FieldConfig[]>([]);

    const carcinogenicReportData = useAppSelector(
        (state) => state.carcinogenicReport.carcinogenicReport
    );

    useEffect(() => {
        const providerFieldsConfig: FieldConfig[] = [
            {
                type: 'autocomplete',
                label: t('newProviderForm.inputs.substance') as string,
                name: 'substance',
                required: true,
                value: newProviderFormData.substance,
                disabled: false,
                helperText: t('newProviderForm.inputs.substance') as string,
                onBlurValidation: handleBlurValidation,
                inputType: 'number',
                gridSpace: { xs: 12 },
                testID: TEST_IDS.newProviderFields.substance,
                options: carcinogenicReportData?.sustancias || [],
                getOptionLabel: (option) => `${option?.codigo} - ${option?.descripcion}`,
                validations: [{ name: 'required' }, { name: 'maxLength', param: 150 }]
            },
            {
                type: 'text',
                label: t('newProviderForm.inputs.chemicalAndComercialName') as string,
                name: 'chemicalAndComercialName',
                required: true,
                value: newProviderFormData.chemicalAndComercialName,
                disabled: false,
                helperText: t('newProviderForm.inputs.chemicalAndComercialName') as string,
                onBlurValidation: handleBlurValidation,
                gridSpace: { xs: 12 },
                inputType: 'text',
                testID: TEST_IDS.newProviderFields.chemicalAndComercialName,
                validations: [{ name: 'required' }, { name: 'maxLength', param: 100 }]
            },
            {
                type: 'text',
                label: t('newProviderForm.inputs.cuit') as string,
                name: 'cuit',
                required: true,
                value: newProviderFormData.cuit,
                disabled: false,
                helperText: t('newProviderForm.inputs.cuit') as string,
                onBlurValidation: handleBlurValidation,
                inputType: 'number',
                maxLength: 11,
                minLength: 11,
                gridSpace: { xs: 12, sm: 6 },
                testID: TEST_IDS.newProviderFields.cuit,
                validations: [
                    { name: 'required' },
                    { name: 'fixedLength', param: 11 },
                    { name: 'cuitModulo11' }
                ]
            },
            {
                type: 'autocomplete',
                label: t('newProviderForm.inputs.type') as string,
                name: 'type',
                required: true,
                value: newProviderFormData.type,
                disabled: false,
                helperText: t('newProviderForm.inputs.type') as string,
                onBlurValidation: handleBlurValidation,
                inputType: 'number',
                gridSpace: { xs: 12, sm: 6 },
                getOptionLabel: (option) => `${option?.descripcion || ''}`,
                options: NEW_PROVIDER_OR_BUYER_TYPE_OPTIONS,
                testID: TEST_IDS.newProviderFields.type,
                validations: [{ name: 'required' }, { name: 'maxLength', param: 50 }]
            }
        ];

        setProviderFieldsConfig(providerFieldsConfig);
    }, []);

    return { providerFieldsConfig };
};

export default useProviderFieldConfig;
